// Public route on the main zone, not api.admin.thecreaksofficial.com — that
// hostname sits entirely behind Cloudflare Access, which would swallow this
// beacon before admin-worker's code ever ran. In production this is actually
// same-origin (the main site already lives on thecreaksofficial.com).
const TRACK_BASE = process.env.REACT_APP_TRACK_BASE || "https://thecreaksofficial.com";

// Reports a landing that carries tracking params (e.g. ?ref=supportact1) to
// the Link Builder tab's campaign analytics — fired once on initial load,
// same sendBeacon technique as hotel's trackPageview (avoids the CORS
// preflight an application/json fetch() would force). A no-op when there
// are no query params, so normal browsing sends nothing.
export function trackCampaignHit() {
  if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return;
  const params = Object.fromEntries(new URLSearchParams(window.location.search));
  if (Object.keys(params).length === 0) return;
  const body = JSON.stringify({ params, url: window.location.href });
  navigator.sendBeacon(`${TRACK_BASE}/api/track/campaign-hit`, new Blob([body], { type: "text/plain" }));
}
